<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_4672_33751)">
            <mask id="mask0_4672_33751" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="22"
                height="23">
                <path d="M0 0.00683594H22V22.0068H0V0.00683594Z" fill="white" />
            </mask>
            <g mask="url(#mask0_4672_33751)">
                <path
                    d="M17.325 1.03809H20.6989L13.3289 9.48294L22 20.9764H15.2114L9.89057 14.0071L3.80914 20.9764H0.432143L8.31443 11.9407L0 1.03966H6.96143L11.7637 7.40866L17.325 1.03809ZM16.1386 18.9524H18.0086L5.94 2.9568H3.93486L16.1386 18.9524Z"
                    fill="white" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4672_33751">
                <rect width="22" height="22" fill="white" transform="translate(0 0.00683594)" />
            </clipPath>
        </defs>
    </svg>
</template>